import type * as React from 'react';
import { Helmet } from 'react-helmet-async';

import IbmPlexMonoBold from '../assets/ibm-plex-mono-bold.woff';
import IbmPlexSansBold from '../assets/ibm-plex-sans-bold.woff';
import IbmPlexSansRegular from '../assets/ibm-plex-sans-regular.woff';
import OpenSansBold from '../assets/open-sans-bold.woff';
import OpenSansCnLt from '../assets/open-sans-condensed-light.woff';
import OpenSansHebrewBold from '../assets/open-sans-hebrew-bold.ttf';
import OpenSansHebrewRegular from '../assets/open-sans-hebrew-regular.ttf';
import OpenSansLt from '../assets/open-sans-light.woff';
import OpenSansRegular from '../assets/open-sans-regular.woff';
import OpenSansSemibold from '../assets/open-sans-semibold.woff';
import PromptBold from '../assets/prompt-bold.ttf';
import PromptRegular from '../assets/prompt-regular.ttf';

const fonts = [
  {
    fontFamily: 'OpenSans Lt',
    woff: OpenSansLt,
    fontWeight: 400,
  },
  {
    fontFamily: 'OpenSans Cn Lt',
    woff: OpenSansCnLt,
    fontWeight: 400,
  },
  {
    fontFamily: 'Open Sans',
    woff: OpenSansRegular,
    fontWeight: 400,
  },
  {
    fontFamily: 'Open Sans',
    woff: OpenSansSemibold,
    fontWeight: 600,
  },
  {
    fontFamily: 'Open Sans',
    woff: OpenSansBold,
    fontWeight: 700,
  },
  {
    fontFamily: 'IBM Plex Mono',
    woff: IbmPlexMonoBold,
    fontWeight: 700,
  },
  {
    fontFamily: 'IBM Plex Sans',
    woff: IbmPlexSansRegular,
    fontWeight: 400,
  },
  {
    fontFamily: 'IBM Plex Sans',
    woff: IbmPlexSansBold,
    fontWeight: 700,
  },
  {
    fontFamily: 'Prompt',
    woff: PromptBold,
    fontWeight: 700,
  },
  {
    fontFamily: 'Prompt',
    woff: PromptRegular,
    fontWeight: 400,
  },
  {
    fontFamily: 'Open Sans Hebrew',
    woff: OpenSansHebrewBold,
    fontWeight: 700,
  },
  {
    fontFamily: 'Open Sans Hebrew',
    woff: OpenSansHebrewRegular,
    fontWeight: 400,
  },
];

const fontsString = fonts
  .map(({ fontFamily, fontWeight, woff }) => {
    return `
      @font-face {
        font-family: "${fontFamily}";
        font-display: block;
        font-weight: ${fontWeight};
        src: url(${woff}) format("woff");
      }`;
  })
  .join('')
  .replace(/\n|^\s+/gm, '');

const links = fonts.map(({ woff }, i) => {
  return (
    <link
      key={i}
      href={woff}
      rel="preload"
      as="font"
      crossOrigin="anonymous"
      type="font/woff"
    />
  );
});

export const TemplateGlobalStyles: React.FC = () => {
  return (
    <Helmet>
      {links}
      <style>{fontsString}</style>
    </Helmet>
  );
};
